import React from 'react';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';
import SkeletonView from '@@viewCommonComponents/groupProtection/SkeletonView.jsx';

const SouscriptionPaymentRefundGroupProtection = ({ getMiddleText }) => (
  <SkeletonView title={'Paiement & remboursement'} getMiddleText={getMiddleText} />
);

export default withMiddleFeatures(SouscriptionPaymentRefundGroupProtection);
